/**
 * Reusable component for displaying subscription limit reached message
 */
import theme from "@shared/utils/themeColors";
import React from "react";
import Button, { ButtonSize, ButtonVariant } from "./ui/Button";
import { ArrowLeftIcon, CopyIcon } from "./ui/Icon";

interface SubscriptionLimitReachedProps {
  resourceType?: string;
  returnPath?: string;
  returnLabel?: string;
}

const SubscriptionLimitReached: React.FC<SubscriptionLimitReachedProps> = ({
  resourceType = "resources",
  returnPath = "/",
  returnLabel = "Return",
}) => {
  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
      <div
        className={`${theme.bg.primary} rounded-lg shadow-lg p-8 max-w-2xl mx-auto`}
      >
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-amber-100 mb-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 text-amber-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
            Upgrade Your Plan
          </h2>
          <div className="h-1 w-16 bg-yellow-500 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-300 mb-6">
            You've reached the limit of free {resourceType}. Upgrade to a
            premium plan to unlock unlimited access and advanced features.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button
              variant={ButtonVariant.TERTIARY}
              size={ButtonSize.LARGE}
              as="navlink"
              to={returnPath}
              leftIcon={<ArrowLeftIcon />}
            >
              {returnLabel}
            </Button>
            <Button
              variant={ButtonVariant.PRIMARY}
              size={ButtonSize.LARGE}
              as="navlink"
              to="/settings/plans"
              leftIcon={<CopyIcon />}
            >
              Upgrade Now
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionLimitReached;
